import { css } from "@styled-system/css";

export const externalProviderLinkClass = css({
	color: "primary.80",
	textDecoration: "underline",
	_hover: {
		color: "primary.100",
	},
});
